var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attact-container"
  }, [_c('swiper', {
    ref: "mySwiper",
    staticClass: "big-swiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "slide"
    }, [_c('img', {
      staticClass: "slide_item",
      attrs: {
        "src": item.imgUrl
      }
    })])
  }), 1), _vm._v(" "), _c('swiper', {
    ref: "swiperThumbs",
    staticClass: "small-swiper gallery-thumbs",
    attrs: {
      "options": _vm.swiperOptionThumbs
    }
  }, _vm._l((_vm.list), function(sitem, sindex) {
    return _c('swiper-slide', {
      key: 's' + sindex,
      staticClass: "slide"
    }, [_c('div', {
      staticClass: "slide_item",
      style: ({
        'backgroundImage': 'url(' + sitem.imgUrl + ')'
      })
    })])
  }), 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-wrap  color-fff fs-14"
  }, [_c('div', {
    staticClass: "flex-container"
  }, [_c('span', [_vm._v("展会名称：第二十二届广州国际汽车展览会")]), _vm._v(" "), _c('span', [_vm._v("Name：The 22"), _c('i', {
    staticClass: "up_text"
  }, [_vm._v("nd")]), _vm._v(" Guangzhou International Automobile Exhibition")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, [_c('span', [_vm._v("展会地点：中国琶洲·广州进出口商品交易会展馆")]), _vm._v(" "), _c('span', [_vm._v("Venue：China Import and Export Fair Complex（Canton Fair Complex）")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, [_c('span', [_vm._v("展会时间：2024.11.15-24")]), _vm._v(" "), _c('span', [_vm._v("Date：2024.11.15-24")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-wrap"
  }, [_c('span', {
    staticClass: "btn-down media_font_size_50"
  }, [_c('a', {
    attrs: {
      "href": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/exhibitor/2024%E5%B9%BF%E5%B7%9E%E8%BD%A6%E5%B1%95%E6%8B%9B%E5%B1%95%E5%87%BD.pdf",
      "target": "_blank"
    }
  }, [_vm._v("招展函下载/Download")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-download"
  })])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91c1287c","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/exhibitor/components/attact.vue
// module id = null
// module chunks = 